import React from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Paper from '@mui/material/Paper';
import { useDispatch } from 'react-redux';
import { setInvoiceDetails, setInvoiceModalOpen } from '../../../store/invoice/invoiceSlice';

const columns = [
  { id: 'invoice_no', label: 'Invoice #'},
  { id: 'invoice_date', label: 'Invoice Date'},
  { id: 'job_no', label: 'Job #'},
  { id: 'ref_no', label: 'Ref #'},
  { id: 'job_type', label: 'Job Type'},
  {id: 'descriptions',label: 'Descriptions'},
  {id: 'status',label: 'Status'},
  {id: 'action',label: 'Actions'}
];

const InvoiceTable = (props) => {
  const {
    is_loading,
    is_invoice_modal_open,
    invoice_data,
  } = props;

  const dispatch = useDispatch();

  const handleModal = (c_action,invoice_id) => {
    dispatch(setInvoiceDetails(invoice_id));
    dispatch(setInvoiceModalOpen(!is_invoice_modal_open));
  };

  return (
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <TableContainer sx={{ maxHeight: {xl:800,md:440} }}>
          <Table stickyHeader aria-label="sticky table">
              <TableHead>
                  <TableRow sx={{
                    '& .MuiTableCell-root:not(:first-of-type)' : {
                      textAlign : 'center',
                    }
                  }}>
                  {columns.map((column) => (
                      <TableCell
                      key={column.id}
                      style={{ minWidth: column.minWidth }}
                      sx={{
                      fontWeight: "bold",
                      backgroundColor: "#eeeeee70",
                      }}
                      >
                      {column.label}
                      </TableCell>
                  ))}
                  </TableRow>
              </TableHead>
              <TableBody>
                  {
                      invoice_data.length > 0 ?
                      invoice_data
                      .map((row,idx) => {
                          return (
                          <TableRow hover role="checkbox" tabIndex={-1} key={idx}>
                              <TableCell align="left">
                                <Stack display='flex' flexDirection='row' alignItems='center'>
                                  <Tooltip title={row.invoice_no || "-"} arrow>
                                  {row.invoice_no}
                                  </Tooltip>
                                </Stack>
                              </TableCell>
                              <TableCell align="center">
                                <Tooltip title={row.invoice_date || "-"} arrow>
                                {row.invoice_date}
                                </Tooltip>
                              </TableCell>
                              <TableCell align="center">
                                <Tooltip title={row.job_no || "-"} arrow>
                                {row.job_no}
                                </Tooltip>
                              </TableCell>
                              <TableCell align="center">
                                <Tooltip title={row.ref_no || "-"} arrow>
                                {row.ref_no}
                                </Tooltip>
                              </TableCell>
                              <TableCell align="center">
                                <Tooltip title={row.job_type || "-"} arrow>
                                {row.job_type}
                                </Tooltip>
                              </TableCell>
                              <TableCell align="center">
                                <Tooltip title={row.descriptions || "-"} arrow>
                                {row.descriptions}
                                </Tooltip>
                              </TableCell>
                              <TableCell align="center">
                                <Tooltip title={row.status || "-"} arrow>
                                {row.status}
                                </Tooltip>
                              </TableCell>
                              <TableCell align="center">
                                  <Stack direction="row" justifyContent='center' spacing={2}>
                                  <Tooltip title="Edit">
                                      <IconButton type="button" aria-label="edit" color='primary' onClick={() => handleModal("UPDATE",row.invoice_no)}>
                                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" style={{width:'1.5rem'}}>
                                        <path strokeLinecap="round" strokeLinejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
                                      </svg>

                                      </IconButton>
                                  </Tooltip>
                                  </Stack>
                              </TableCell>
                          </TableRow>
                          );
                      }): !is_loading && invoice_data.length === 0 ? <TableRow><TableCell align='center' colSpan={8}>No Record Found</TableCell></TableRow> : <TableRow><TableCell align='center' colSpan={8}>loading....</TableCell></TableRow>
                  }
              </TableBody>
          </Table>
      </TableContainer>
    </Paper>
  )
}

export default InvoiceTable;